import Axios, { AxiosResponse } from "axios";
import { KuikaAppManager } from "../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../shared/utilty/main-functions";

const backendUrl = KuikaAppManager.GetBackendUrl();

interface IPushToCacheRequest {
  key: string;
  value: string;
  cacheRegion: number;
}

interface IPushToCacheResponse {
  isSuccess: boolean;
}

interface IFetchFromCacheResponse {
  value: string;
}

interface IRemoveFromCacheResponse {
  isSuccess: boolean;
}

interface ICheckKeyExistenceResponse {
  isExist: boolean;
}

export class CacheService {
  public static async PushToCache(request: IPushToCacheRequest): Promise<AxiosResponse<IPushToCacheResponse>> {
    try {
      return await Axios.post<IPushToCacheRequest, AxiosResponse>(`${backendUrl}/Cache/addToCache`, request);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async FetchFromCache(
    key: string,
    cacheRegion: number
  ): Promise<AxiosResponse<IFetchFromCacheResponse>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/Cache/fetchFromCache`, {
        params: { key, cacheRegion }
      });
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async RemoveFromCache(
    key: string,
    cacheRegion: number
  ): Promise<AxiosResponse<IRemoveFromCacheResponse>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/Cache/removeFromCache`, {
        params: { key, cacheRegion }
      });
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async CheckKeyExistence(
    key: string,
    cacheRegion: number
  ): Promise<AxiosResponse<ICheckKeyExistenceResponse>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/Cache/checkKeyExistence`, {
        params: { key, cacheRegion }
      });
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
